import { AuthEntity, AuthInterface } from "interfaces";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setLoginType } from "reducer/logintype.slice";
import { api, ui } from "services";

export default function RequestTokenPage() {
    const { search } = useLocation();
    const nav = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const checkRedirect = async () => {
        try {
            const query = new URLSearchParams(search);
            const requestKey = query.get('requestKey');
            const userId = query.get('userId');
            if (requestKey && userId) {
                const { daoToken, customerInfo } = await api.claimTokenRequest(requestKey, userId);
                if (daoToken) {
                    sessionStorage.setItem("token", daoToken);
                    const authInfo: AuthEntity[] = await api.getAuthInfos();
                    if (authInfo.length === 0) {
                        throw new Error("invalid_auth");
                    }
                    const loginType = authInfo[0][AuthInterface.type] ?? 0;
                    await api.setStateLogin(daoToken, customerInfo, authInfo, loginType);
                    dispatch(setLoginType(loginType));
                    nav('/');
                }
            }
        } catch (err: any) {
            ui.alertFailed("", t(err.message))
        }
    }
    useEffect(() => {
        checkRedirect();
    }, [])

    return (
        <></>
    )
}
